module.exports = "/images/ja.svg";